/**
 * Created by Vladislav on 30.03.2025.
 */

const IndexedDBStore = function (storeName) {
    this.storeName = storeName;

    this.callbacks = [];

    this.connection = indexedDB.open(`${cleverapps.config.name}-${storeName}`, 1);

    this.connection.onupgradeneeded = function (event) {
        const db = event.target.result;
        db.createObjectStore(storeName, { keyPath: "id" });
    };

    this.connection.onsuccess = function (event) {
        this.db = event.target.result;

        this.ready = true;

        this.callbacks.forEach((callback) => {
            callback();
        });

        this.callbacks = [];
    }.bind(this);
};

IndexedDBStore.prototype._whenReady = function (callback) {
    if (this.ready) {
        callback();
    } else {
        this.callbacks.push(callback);
    }
};

IndexedDBStore.prototype.get = function (id, callback) {
    this._whenReady(() => {
        const transaction = this.db.transaction(this.storeName, "readonly");
        const store = transaction.objectStore(this.storeName);

        const request = store.get(id);
        request.onsuccess = function () {
            callback(request.result && request.result.data && JSON.parse(request.result.data));
        };
        request.onerror = function (err) {
            console.error(err);

            callback();
        };
    });
};

IndexedDBStore.prototype.set = function (id, data, callback) {
    this._whenReady(() => {
        const transaction = this.db.transaction(this.storeName, "readwrite");
        const store = transaction.objectStore(this.storeName);

        const request = store.put({ id, data: JSON.stringify(data) });

        request.onsuccess = function () {
            callback(request.result);
        };
        request.onerror = callback;
    });
};